import { CreateVisitType } from '@features/visits/entity';
import { useFormContext, useWatch } from 'react-hook-form';
import { useParams } from 'react-router';

export const useVisitForm = () => {
  const { clientId } = useParams();
  const { control } = useFormContext<CreateVisitType>();

  const serviceIds = useWatch({ control, name: 'serviceIds' });
  const showManualDatePickers = useWatch({ control, name: 'manualDateTimeOverride' });

  return {
    clientId,
    serviceIds,
    showManualDatePickers: !!showManualDatePickers,
  };
};

export const validateTimeIsSelected = (data: CreateVisitType) => {
  const { date, dateTo } = data;

  if (!date || !dateTo) {
    return true;
  }

  return date.getTime() === dateTo.getTime() ? 'visitDateTimeValidation' : true;
};
